import React from 'react';
import { LoaderFunctionArgs, useLoaderData } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';
import { createApolloClient } from '../../providers/ApolloClientFactory';
import { RFID_BY_UID_QUERY_EXPANDED } from '../rfid_assets/queries';
import { RFID } from '../../types/rfid';

const client = createApolloClient();

export const QrCodeTicketingDisplayLoader = async ({ params }: LoaderFunctionArgs) => {
  const { uid } = params;
  const { data } = await client.query({
    query: RFID_BY_UID_QUERY_EXPANDED,
    variables: { uid },
  });
  return {
    data: data.rfid_assets?.[0],
    uid,
  };
};

export const QrCodeTicketingDisplay = () => {
  const { data, uid } = useLoaderData() as {
    data: RFID;
    uid: string;
  };

  const tokensBalance = data?.tokens_balance;
  let tokenStrings;
  if (tokensBalance && Object.keys(tokensBalance).length > 0) {
    tokenStrings = Object.values<any>(tokensBalance).map(
        (token) => `${token.redeemable_token_name} - ${token.balance}`
    );
  }

  const cashBalance = data?.cash_balance || 0;
  const promoBalance = data?.promo_balance || 0;

  // A ticket has an entry type; a code made only to hold money (top-up / create asset) doesn't.
  const isTicket = !!data?.access_type?.trim();
  const hasBalance = !!tokenStrings || cashBalance > 0 || promoBalance > 0;
  const eventName = data?.event?.name;

  const heading = isTicket ? 'ticket' : 'payment code';
  let instructions = 'Show this QR code when you pay.';
  if (isTicket) {
    instructions = hasBalance
      ? 'Show this QR code at the entrance. You can also use it to pay.'
      : 'Show this QR code at the entrance.';
  }

  return (
      <div className="flex flex-col items-center justify-center bg-white p-4 min-h-screen">
        <div className="text-center mb-4">
          <h1 className="text-2xl mb-2">
            {eventName ? <>Your <strong>{eventName}</strong> {heading}</> : <>Your {heading}</>}
          </h1>
          <p>{instructions}</p>
        </div>
        <div className="flex justify-center">
          <QRCodeSVG value={data.uid.toString()} width="240" height="240" />
        </div>
        <div className="flex flex-col justify-center mt-5">
          {tokenStrings && (
            <p className="text-center">
              <strong>Token Balance:</strong> {tokenStrings.join(', ')}
            </p>
          )}
          {cashBalance > 0 && (
            <p className="text-center">
              <strong>Cash Balance:</strong> ${(cashBalance / 100).toFixed(2)}
            </p>
          )}
          {promoBalance > 0 && (
            <p className="text-center">
              <strong>Promo Balance:</strong> ${(promoBalance / 100).toFixed(2)}
            </p>
          )}
        </div>
      </div>
  );
};
